import React from 'react';
import {LEAGUE_CONFIGS} from '../../configs/leagues';
import {getLeagueByRating} from '../../utils/rating/getLeagueByRating';
import {getNextLeagueMinRating} from '../../utils/rating/shiftLeague';

// От самой престижной лиги к самой начальной
const LEAGUES_DESC = [...LEAGUE_CONFIGS].sort((a, b) => b.minRating - a.minRating);

/**
 * Список лиг с порогами рейтинга (раньше показывался первые секунды поиска
 * матча). У лиги игрока — его рейтинг и сколько осталось до следующей лиги, а
 * сама плашка подсвечена пульсирующим свечением (как выбранная фракция в
 * лобби). Плашки — в стилистике .game-end-player-info из результатов демо-игры.
 */
function RankLeaguesTable({rating}) {
  const playerLeague = getLeagueByRating(rating);
  const nextLeagueMinRating = getNextLeagueMinRating(playerLeague.id);
  const nextLeague = LEAGUE_CONFIGS.find((league) => league.minRating === nextLeagueMinRating);

  return (
    <div className="rank-match-leagues-widget_content">
      <div className="rank-match-leagues-widget-title">
        <span className={'rank-match-league-header-margin'}>Лиги</span>
        <span className="text-rating">Рейтинг</span>
      </div>
      {LEAGUES_DESC.map((league) => (
        <div
          key={league.id}
          className={`rank-match-league-row league-${league.id} ${
            playerLeague.id === league.id ? 'rank-match-league-row_current' : ''}`}
        >
          <img
            className="rank-match-league-icon"
            src={league.iconPath}
            alt={''}
          />
          <span className="rank-match-league-name">{league.name.replace('лига', '')}</span>
          <span className="rank-match-league-range text-rating">{league.minRating}</span>
          {playerLeague.id === league.id && (
            <>
              <div className="rank-match-league-your">
                <span className="text-attention">Ваш рейтинг</span>
                <span className="text-rating">{rating}</span>
              </div>
              {nextLeague && (
                <div className="rank-match-league-your rank-match-league-your_next">
                  <span>{`До лиги «${nextLeague.name.replace(' лига', '')}»`}</span>
                  <span className="text-rating">{nextLeague.minRating - rating}</span>
                </div>
              )}
            </>
          )}
        </div>
      ))}
    </div>
  );
}

export default RankLeaguesTable;
